import { getSearchParams, removeSearchParams } from './urlQuery'

interface AiLoginEntry {
  source: string
  apiKey: string
}

let entry: AiLoginEntry | null = null
const entryKey = Symbol.for('qx.aiLoginEntry')

const getHashSearch = (hash: string) => {
  const queryStart = hash.indexOf('?')
  return queryStart === -1 ? '' : hash.slice(queryStart)
}

const readEntry = (url: URL): AiLoginEntry | null => {
  const searchParams = getSearchParams(url.search)
  const hashParams = getSearchParams(getHashSearch(url.hash))
  const source = (searchParams.get('source') || hashParams.get('source') || '').trim()
  const apiKey = (
    searchParams.get('apikey')
    || searchParams.get('apiKey')
    || hashParams.get('apikey')
    || hashParams.get('apiKey')
    || ''
  ).trim()

  return source && apiKey.length === 32 ? { source, apiKey } : null
}

export const scrubAiLoginApiKeyFromAddress = () => {
  if (typeof window === 'undefined') return

  const url = new URL(window.location.href)
  url.search = removeSearchParams(url.search, ['apikey', 'apiKey'])

  const hashQueryStart = url.hash.indexOf('?')
  if (hashQueryStart !== -1) {
    const hashPath = url.hash.slice(0, hashQueryStart)
    const hashSearch = removeSearchParams(url.hash.slice(hashQueryStart), ['apikey', 'apiKey'])
    url.hash = `${hashPath}${hashSearch}`
  }

  if (url.toString() !== window.location.href) {
    window.history.replaceState(window.history.state, '', url.toString())
  }
}

// 必须在监控与埋点初始化前同步调用，避免凭据进入页面 URL 采集。
export const prepareAiLoginEntry = () => {
  if (typeof window === 'undefined') return
  const bootstrapEntry = (window as unknown as Record<symbol, AiLoginEntry | undefined>)[entryKey]
  entry = bootstrapEntry || readEntry(new URL(window.location.href))
  scrubAiLoginApiKeyFromAddress()
}

export const getAiLoginEntry = (): Readonly<AiLoginEntry> | null => {
  if (typeof window === 'undefined') return entry
  const bootstrapEntry = (window as unknown as Record<symbol, AiLoginEntry | undefined>)[entryKey]
  delete (window as unknown as Record<symbol, AiLoginEntry | undefined>)[entryKey]
  entry ||= bootstrapEntry || null
  return entry
}

export const consumeAiLoginEntry = (): Readonly<AiLoginEntry> | null => {
  const current = getAiLoginEntry()
  entry = null
  return current
}
